import styles from "./CodesSummery.module.css";
import { useEffect, useState } from "react";
import getCodesSummary from "../../utils/getCodesSummery";
import { useCodes } from "../../contexts/CodesContext";
import Skeleton from "@mui/material/Skeleton";
const NotUsedCodesSummery = () => {
  interface Summary {
    usedCodes: number;
    notUsedCodes: number;
    totalCodes: number;
    used500Codes: number;
    used1000Codes: number;
    notUsed500Codes: number;
    notUsed1000Codes: number;
  }

  const { reloadCodes } = useCodes();

  const [summary, setSummary] = useState<Summary | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCodes = async () => {
      setLoading(true);
      const codes = await getCodesSummary();
      setSummary(codes);
      setLoading(false);
    };
    fetchCodes();
  }, [reloadCodes]);

  return (
    <div className={styles.summaryContainer}>
      {loading ? (
        <>
          <div className={styles.summaryItem}>
            <div className={styles.summaryItemTitle}>סה״כ מספרים פנויים:</div>
            <div className={styles.summaryItemValue}>
              <Skeleton variant="rectangular" width={15} height={10} />
            </div>
          </div>
          <div className={styles.summaryItem}>
            <div className={styles.summaryItemTitle}>
              500 <span className={styles.summaryItemCurrency}>₪</span>
            </div>
            <div className={styles.summaryItemValue}>
              <Skeleton variant="rectangular" width={15} height={10} />
            </div>
          </div>
          <div className={styles.summaryItem}>
            <div className={styles.summaryItemTitle}>
              1000 <span className={styles.summaryItemCurrency}>₪</span>
            </div>
            <div className={styles.summaryItemValue}>
              <Skeleton variant="rectangular" width={15} height={10} />
            </div>
          </div>
        </>
      ) : (
        <>
          <div className={styles.summaryItem}>
            <div className={styles.summaryItemTitle}>סה״כ מספרים פנויים:</div>
            <div className={styles.summaryItemValue}>
              {summary?.notUsedCodes}
            </div>
          </div>
          <div className={styles.summaryItem}>
            <div className={styles.summaryItemTitle}>
              500 <span className={styles.summaryItemCurrency}>₪</span>
            </div>
            <div className={styles.summaryItemValue}>
              {summary?.notUsed500Codes}
            </div>
          </div>
          <div className={styles.summaryItem}>
            <div className={styles.summaryItemTitle}>
              1000 <span className={styles.summaryItemCurrency}>₪</span>
            </div>
            <div className={styles.summaryItemValue}>
              {summary?.notUsed1000Codes}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default NotUsedCodesSummery;
